var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgCongrats(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 161,
    height: 160,
    viewBox: "0 0 161 160",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "icon"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Union",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M80.5 138C112.533 138 138.5 112.033 138.5 80C138.5 47.9675 112.533 22 80.5 22C48.4675 22 22.5 47.9675 22.5 80C22.5 112.033 48.4675 138 80.5 138ZM80.5 140C113.637 140 140.5 113.137 140.5 80C140.5 46.8629 113.637 20 80.5 20C47.3629 20 20.5 46.8629 20.5 80C20.5 113.137 47.3629 140 80.5 140ZM117.81 68.2167L107.708 58.1152L75.3833 90.44L59.2209 74.2776L49.1193 84.3791L75.3833 110.643L117.81 68.2167Z",
    fill: "#3BB861"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCongrats);
export default __webpack_public_path__ + "static/media/congrats.4a755000d13c3bd91c4731d5f8c94336.svg";
export { ForwardRef as ReactComponent };